/**
 * COP Cart Drawer — Trash / Minus icon toggle
 *
 * When qty == 1 the minus button shows a trash-can icon.
 * When qty  > 1 it shows the standard minus icon.
 * Clicking the trash icon (qty == 1) removes the item from the cart.
 */
(function () {
  function updateMinusIcons(scope) {
    const root = scope || document;
    root.querySelectorAll('cart-drawer quantity-input.cart-quantity').forEach(function (qi) {
      const input = qi.querySelector('.quantity__input');
      if (!input) return;

      const minusBtn = qi.querySelector('button[name="minus"]');
      if (!minusBtn) return;

      const iconMinus = minusBtn.querySelector('.icon-minus-svg');
      const iconTrash = minusBtn.querySelector('.icon-trash-svg');
      if (!iconMinus || !iconTrash) return;

      const qty = parseInt(input.value, 10);

      if (qty <= 1) {
        iconMinus.classList.add('hidden');
        iconTrash.classList.remove('hidden');
      } else {
        iconMinus.classList.remove('hidden');
        iconTrash.classList.add('hidden');
      }
    });
  }

  // Handle minus button click when qty is 1 → remove item
  document.addEventListener('click', function (e) {
    const minusBtn = e.target.closest('cart-drawer quantity-input.cart-quantity button[name="minus"]');
    if (!minusBtn) return;

    const qi = minusBtn.closest('quantity-input');
    const input = qi && qi.querySelector('.quantity__input');
    if (!input) return;

    const qty = parseInt(input.value, 10);
    if (qty <= 1) {
      // Find the associated cart-remove-button element (its own click
      // handler dispatches updateQuantity(index, 0) to remove the line item).
      const wrapper = minusBtn.closest('.cart-item__quantity-wrapper');
      const removeEl = wrapper && wrapper.querySelector('cart-remove-button');
      if (removeEl) {
        e.preventDefault();
        e.stopImmediatePropagation();
        removeEl.click();
      }
    }
  }, true); // capture phase so we run before QuantityInput's handler

  // Listen for input value changes to toggle icons in real-time
  document.addEventListener('change', function (e) {
    if (e.target.matches('cart-drawer quantity-input.cart-quantity .quantity__input')) {
      updateMinusIcons();
    }
  });

  // Also listen for the QuantityInput stepUp/stepDown dispatched change
  // Use MutationObserver on the input value as a fallback
  const observer = new MutationObserver(function () {
    updateMinusIcons();
  });

  function observeDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      observer.observe(drawer, { childList: true, subtree: true });
      updateMinusIcons();
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }
})();
